<template>
  <h-btn color="primary" @click="open" type="button">Update Credit Card</h-btn>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";

const CREDIT_CARD_STORE = "OwnerCreditCards";
export default {
  data() {
    return {
      change: false
    };
  },
  mounted() {
    // eslint-disable-next-line
    this.handler = StripeCheckout.configure({
      key: `${process.env.VUE_APP_STRIPE_KEY}`,
      image: "https://stripe.com/img/documentation/checkout/marketplace.png",
      locale: "auto",
      panelLabel: "Change Credit Card",
      email: User.email,
      token: token => {
        let card = token.card;
        card.token = token.id;
        card.stripe_id = card.id;
        card.id = undefined;
        card.last_four = card.last4;
        dataStore
          .create(CREDIT_CARD_STORE, card)
          .then(() => {
            snackbar.update("Saved");
            this.$emit("newCard", card);
          })
          .catch(() => {
            snackbar.update("There was an error. Our staff has been notified");
          });
      }
    });
  },
  methods: {
    open() {
      this.handler.open({
        name: "HabitTechnologies.com"
      });
    }
  }
};
</script>
